'use strict';

/**
 * Function to check that imageUrl is from cdnUrl will need to explicit convert to String.
 * Similar Problem
 * https://stackoverflow.com/questions/38813040/startswith-is-not-a-function-getting-called-for-no-reason
 */
var isImageFromOptimizingCdn = function (imageUrl, cdnBaseUrl) {
    return cdnBaseUrl && imageUrl && String(imageUrl).startsWith(cdnBaseUrl);
};

exports.isImageFromOptimizingCdn = isImageFromOptimizingCdn;
//# sourceMappingURL=isImageFromOptimizingCdn.js.map
